import {Controller} from '@hotwired/stimulus'

// The sidebar Help popover (GF-2954). Replaces the reactstrap Popover the
// React SettingsSection used: click toggles the panel, clicking anywhere
// outside (or pressing Escape) closes it — reactstrap's trigger="legacy".
export default class extends Controller {
  static targets = ['panel', 'button']

  connect() {
    this.handleOutsideClick = (event) => {
      if (this.panelTarget.hidden)
        return
      if (this.element.contains(event.target))
        return
      this.close()
    }
    this.handleKeydown = (event) => {
      if (event.key === 'Escape')
        this.close()
    }
    document.addEventListener('click', this.handleOutsideClick)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
    document.removeEventListener('keydown', this.handleKeydown)
  }

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden
    this.buttonTarget.setAttribute('aria-expanded', this.panelTarget.hidden ? 'false' : 'true')
  }

  close() {
    this.panelTarget.hidden = true
    this.buttonTarget.setAttribute('aria-expanded', 'false')
  }
}
